module.exports = __webpack_public_path__ + "img/cloud-upload-outline.0a085915.svg";